/* import __COLOCATED_TEMPLATE__ from './file-question.hbs'; */
import { DOCUMENT_SIDES } from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './file-question.module.scss';

export default class RequestPrescreenerQuestionTypesFileQuestion extends Component {
  @service prescreener;
  @service media;

  styles = styles;

  get isDesktopFeatureEnabled() {
    return !this.media.isXsDown;
  }

  get context() {
    return this.isDesktopFeatureEnabled ? 'forDesktop' : 'forMobile';
  }

  get primaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.primary`;
  }

  get secondaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.secondary`;
  }

  get sides() {
    return DOCUMENT_SIDES[this.questionName] || DOCUMENT_SIDES.DEFAULT;
  }

  get questionName() {
    return this.args.question?.name;
  }

  get clientType() {
    return this.args.clientType;
  }

  get subText() {
    if (this.args.question.subtext) {
      return this.intl.t(this.args.question.subtext);
    }
    return null;
  }

  get metadataProperties() {
    return {
      questionName: this.questionName,
      clientType: this.clientType,
    };
  }

  @action
  getFileFor(side) {
    let fileUpload = this.prescreener.upload.getFile({
      ...this.metadataProperties,
      side,
    });
    return fileUpload?.file;
  }

  @action
  onUploadFile(fileUpload, side) {
    let { questionName, clientType } = this;
    this.prescreener.upload.addFileForQuestion({
      questionName,
      clientType,
      fileUpload,
      side,
    });
    this.sendOnChange(`${side}-${fileUpload?.name}`);
  }

  sendOnChange(fileName) {
    this.args.onChange?.(this.args.question, fileName);
  }
}
